import React, { useState, useEffect, useMemo } from 'react';
import { Typography, Tag } from 'antd';
import dayjs from 'dayjs';
import CrudPage from '../../../components/common/CrudPage';
import { contentCategoryService } from '../../../services/cms/contentManagementService';

const { Text } = Typography;

const STATUS_OPTIONS = [
  { label: 'Active', value: 1 }, { label: 'Inactive', value: 0 },
];

const columns = [
  { title: 'ID', dataIndex: 'id', key: 'id', width: 60 },
  { title: 'TÊN', dataIndex: 'title', key: 'title', render: (t) => <Text strong>{t}</Text> },
  {
    title: 'DANH MỤC CHA', dataIndex: 'parent_id', key: 'parent_id', width: 200,
    render: (id, record) => {
      if (!id) return '--';
      return record.parent_id_name ? `[${id}] ${record.parent_id_name}` : id;
    },
  },
  { title: 'MÔ TẢ', dataIndex: 'description', key: 'description', width: 250, ellipsis: true },
  { title: 'TRẠNG THÁI', dataIndex: 'status', key: 'status', width: 100, render: (s) => <Tag color={s === 1 ? 'green' : 'red'}>{s === 1 ? 'ACTIVE' : 'INACTIVE'}</Tag> },
  { title: 'NGÀY TẠO', dataIndex: 'create_time', key: 'create_time', width: 140, render: (t) => t ? dayjs(t).format('DD/MM/YYYY HH:mm') : '-' },
];

const QuanLyDanhMucNoiDung = () => {
  const [categories, setCategories] = useState([]);

  useEffect(() => {
    contentCategoryService.listActive().then((res) => {
      if (Array.isArray(res)) {
        setCategories(res.map((c) => ({ label: `[${c.id}] ${c.title}`, value: c.id })));
      }
    });
  }, []);

  const formFields = useMemo(() => [
    { name: 'title', label: 'Tên danh mục', type: 'input', rules: [{ required: true, message: 'Vui lòng nhập tên!' }] },
    { name: 'parent_id', label: 'Danh mục cha', type: 'select', options: categories, propsInput: { showSearch: true, allowClear: true, placeholder: 'Không có (để trống)' } },
    { name: 'description', label: 'Mô tả', type: 'textarea' },
    { name: 'status', label: 'Trạng thái', type: 'select', options: STATUS_OPTIONS, defaultValue: 1 },
  ], [categories]);

  const filterFields = useMemo(() => [
    {
      label: 'Chọn danh mục',
      value: 'parent_id',
      options: [{ label: 'Tất cả danh mục', value: '' }, ...categories],
    },
  ], [categories]);

  return (
    <CrudPage
      title="QUẢN LÝ DANH MỤC NỘI DUNG"
      subTitle="Danh mục phân loại bài viết, nội dung"
      itemsName="Danh mục"
      queryKey="contentCategoryList"
      service={contentCategoryService}
      columns={columns}
      formFields={formFields}
      filterFields={filterFields}
      searchPlaceholder="Tìm kiếm theo tên..."
      addButtonLabel="Thêm danh mục"
    />
  );
};

export default QuanLyDanhMucNoiDung;
